import { useModalContext } from 'src/hooks/useModalContext';
import { GPTGameNameType } from '../types';

export const useGPTGameTrigger = () => {
  const { openModal } = useModalContext();

  const triggerGPTGame = (gameName: GPTGameNameType, modalProps?: { [key: string]: unknown }) => {
    openModal('GPT_GAME_MODAL', {
      props: {
        gameName,
        ...modalProps
      }
    });
  };

  return { triggerGPTGame };
};
